import styled from 'styled-components';
import { Button } from 'components/common';

export const ButtonDeleteStyled = styled(Button)`
  padding: 4px 11px;
  height: 26px;
`;
